Ext.define('SA.ChartLegendContent', {
    alias: 'widget.chart-legend-content',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-chart-legend-content'
});